const BANK_CODES = [
    { bankCode: '41829', bankLabel: 'Al Khaliji (France)' },
    { bankCode: '12548', bankLabel: 'Axa Banque' },
    { bankCode: '14908', bankLabel: 'Banca Popolare di Sondrio (Suisse)' },
    { bankCode: '12589', bankLabel: 'Banco BPI' },
    { bankCode: '19229', bankLabel: 'Banco de Sabadell (France)' },
    { bankCode: '41139', bankLabel: 'Banco do Brasil (France)' },
    { bankCode: '12508', bankLabel: 'Banco Guipuzcoano' },
    { bankCode: '44729', bankLabel: 'Banco Santander (France)' },
    { bankCode: '18089', bankLabel: 'Bank Audi Saradar (France)' },
    { bankCode: '41259', bankLabel: 'Bank Melli Iran (France)' },
    { bankCode: '41219', bankLabel: 'Bank of America (France)' },
    { bankCode: '18769', bankLabel: 'Bank of China (France)' },
    { bankCode: '14879', bankLabel: 'Bank of India' },
    { bankCode: '41239', bankLabel: 'Bank Polska Kasa Opieki Spolka Akcyjna (France)' },
    { bankCode: '44269', bankLabel: 'Bank Saderat Iran (France)' },
    { bankCode: '17799', bankLabel: 'Bank Sepah (France)' },
    { bankCode: '17579', bankLabel: 'Bank Tejarat (France)' },
    { bankCode: '12448', bankLabel: 'Banque Barclays (Monaco)' },
    { bankCode: '17519', bankLabel: 'Banque Centrale de Compensation' },
    { bankCode: '30001', bankLabel: 'Banque de France' },
    { bankCode: '43799', bankLabel: 'Banque de Gestion Privée Indosuez BGPI' },
    { bankCode: '44149', bankLabel: 'Banque d\'Escompte' },
    { bankCode: '19089', bankLabel: 'Banque d\'Orsay' },
    { bankCode: '10071', bankLabel: 'Banque du Trésor Public' },
    { bankCode: '41599', bankLabel: 'Banque Française' },
    { bankCode: '18729', bankLabel: 'Banque Française Commerciale Antilles Guyane (Société Générale)' },
    { bankCode: '18719', bankLabel: 'Banque Française Commerciale Océan Indien (Société Générale)' },
    { bankCode: '11668', bankLabel: 'Banque Gestion Edmond de Rothschild (Monaco)' },
    { bankCode: '13807', bankLabel: 'Banque Populaire Atlantique' },
    { bankCode: '10807', bankLabel: 'Banque Populaire Bourgogne France Comté' },
    { bankCode: '13607', bankLabel: 'Banque Populaire Centre Atlantique' },
    { bankCode: '15607', bankLabel: 'Banque Populaire Côte d\'Azur' },
    { bankCode: '17607', bankLabel: 'Banque Populaire d\'Alsace' },
    { bankCode: '12169', bankLabel: 'Banque Populaire de la Réunion' },
    { bankCode: '16707', bankLabel: 'Banque Populaire de l\'Ouest' },
    { bankCode: '10548', bankLabel: 'Banque Populaire de Savoie' },
    { bankCode: '12239', bankLabel: 'Banque Populaire de Tahiti' },
    { bankCode: '16807', bankLabel: 'Banque Populaire des Alpes' },
    { bankCode: '41839', bankLabel: 'Banque Populaire des Antilles Françaises' },
    { bankCode: '11907', bankLabel: 'Banque Populaire du Massif Central' },
    { bankCode: '13507', bankLabel: 'Banque Populaire du Nord' },
    { bankCode: '16607', bankLabel: 'Banque Populaire du Sud' },
    { bankCode: '10907', bankLabel: 'Banque Populaire du Sud Ouest' },
    { bankCode: '13907', bankLabel: 'Banque Populaire Loire et Lyonnais' },
    { bankCode: '14707', bankLabel: 'Banque Populaire Lorraine Champagne' },
    { bankCode: '17807', bankLabel: 'Banque Populaire Occitane' },
    { bankCode: '14607', bankLabel: 'Banque Populaire Provençale et Corse' },
    { bankCode: '10207', bankLabel: 'Banque Populaire Rives de Paris' },
    { bankCode: '18707', bankLabel: 'Banque Populaire Val de France' },
    { bankCode: '44319', bankLabel: 'Banque Privée Européenne (BPE)' },
    { bankCode: '30588', bankLabel: 'Barclays' },
    { bankCode: '18829', bankLabel: 'BCME Banque Commerciale pour le Marché de l\'Entreprise' },
    { bankCode: '12179', bankLabel: 'BIA (Banque Intercontinentale Arabe)' },
    { bankCode: '17599', bankLabel: 'Blom Bank (France)' },
    { bankCode: '12249', bankLabel: 'BMCE Bank International PLC' },
    { bankCode: '17619', bankLabel: 'BMO Banque de l\'Europe Méridionale' },
    { bankCode: '11378', bankLabel: 'BNP Banco Portugues de Negocios SA' },
    { bankCode: '30004', bankLabel: 'BNP Paribas' },
    { bankCode: '40198', bankLabel: 'BNP Paribas (Siège Social)' },
    { bankCode: '40168', bankLabel: 'BNP Paribas de Bretagne' },
    { bankCode: '13078', bankLabel: 'BNP Paribas de la Guadeloupe' },
    { bankCode: '11729', bankLabel: 'BNP Paribas de la Guyane' },
    { bankCode: '13088', bankLabel: 'BNP Paribas de la Martinique' },
    { bankCode: '17939', bankLabel: 'BNP Paribas de la Nouvelle Calédonie' },
    { bankCode: '41919', bankLabel: 'BNP Paribas de la Réunion' },
    { bankCode: '11498', bankLabel: 'BNP Paribas de Monaco' },
    { bankCode: '30958', bankLabel: 'BNP Paribas Lease Group' },
    { bankCode: '40618', bankLabel: 'Boursorama Banque' },
    { bankCode: '11468', bankLabel: 'BPI (Banque Patrimoine et Immobilier)' },
    { bankCode: '10107', bankLabel: 'BRED' },
    { bankCode: '17499', bankLabel: 'BRED Nouvelle Calédonie' },
    { bankCode: '11018', bankLabel: 'BSI Monaco SAM' },
    { bankCode: '30258', bankLabel: 'BTP Banque' },
    { bankCode: '18129', bankLabel: 'CACEIS Bank' },
    { bankCode: '15429', bankLabel: 'Caisse Agricole et Caisse Crédit Mutuel' },
    { bankCode: '18609', bankLabel: 'Caisse Centrale de Crédit Immobilier de France (CIF)' },
    { bankCode: '15549', bankLabel: 'Caisse Crédit Mutuel Agricole et Rural Océan' },
    { bankCode: '13335', bankLabel: 'Caisse d\'Épargne Aquitaine Poitou Charentes' },
    { bankCode: '12135', bankLabel: 'Caisse d\'Épargne Bourgogne Franche Comté' },
    { bankCode: '14445', bankLabel: 'Caisse d\'Épargne Bretagne Pays de Loire' },
    { bankCode: '18315', bankLabel: 'Caisse d\'Épargne Côte d\'Azur' },
    { bankCode: '16705', bankLabel: 'Caisse d\'Épargne d\'Alsace' },
    { bankCode: '18715', bankLabel: 'Caisse d\'Épargne d\'Auvergne et du Limousin' },
    { bankCode: '13135', bankLabel: 'Caisse d\'Épargne de Midi Pyrénées' },
    { bankCode: '18025', bankLabel: 'Caisse d\'Épargne de Picardie' },
    { bankCode: '13485', bankLabel: 'Caisse d\'Épargne du Languedoc Roussillon' },
    { bankCode: '17515', bankLabel: 'Caisse d\'Épargne Ile de France' },
    { bankCode: '14505', bankLabel: 'Caisse d\'Épargne Loire Centre' },
    { bankCode: '14265', bankLabel: 'Caisse d\'Épargne Loire Drôme Ardèche' },
    { bankCode: '15135', bankLabel: 'Caisse d\'Épargne Lorraine Champagne Ardenne' },
    { bankCode: '16275', bankLabel: 'Caisse d\'Épargne Nord France Europe' },
    { bankCode: '11425', bankLabel: 'Caisse d\'Épargne Normandie' },
    { bankCode: '11315', bankLabel: 'Caisse d\'Épargne Provence Alpes Corse' },
    { bankCode: '13825', bankLabel: 'Caisse d\'Épargne Rhône Alpes' },
    { bankCode: '40031', bankLabel: 'Caisse des Dépôts et Consignations' },
    { bankCode: '13798', bankLabel: 'Caisse Solidaire' },
    { bankCode: '12518', bankLabel: 'Caja Ahor Mont Pied Guipuzcoa Seba Kutxa' },
    { bankCode: '19870', bankLabel: 'Carrefour Banque' },
    { bankCode: '25709', bankLabel: 'CGAIM Caisse de Garantie de l\'Immobilier' },
    { bankCode: '12619', bankLabel: 'CGD (Caixa Geral de Depositos)' },
    { bankCode: '41439', bankLabel: 'Chaabi du Maroc' },
    { bankCode: '24659', bankLabel: 'Chabrières' },
    { bankCode: '10178', bankLabel: 'Chaix' },
    { bankCode: '10188', bankLabel: 'Chalus' },
    { bankCode: '10918', bankLabel: 'Cholet Dupont' },
    { bankCode: '30066', bankLabel: 'CIC' },
    { bankCode: '30027', bankLabel: 'CIC du Nord Ouest' },
    { bankCode: '30087', bankLabel: 'CIC Est' },
    { bankCode: '10096', bankLabel: 'CIC Lyonnaise de Banque' },
    { bankCode: '30047', bankLabel: 'CIC Ouest' },
    { bankCode: '10057', bankLabel: 'CIC Sud Ouest' },
    { bankCode: '30568', bankLabel: 'CIC Transatlantique' },
    { bankCode: '17569', bankLabel: 'CIE Monegasque' },
    { bankCode: '17629', bankLabel: 'Commerzbank (France)' },
    { bankCode: '30051', bankLabel: 'Compagnie de Financement Foncier' },
    { bankCode: '42529', bankLabel: 'Compagnie Financière Edmond de Rothschild' },
    { bankCode: '18189', bankLabel: 'Compagnie Générale de Crédit aux Particuliers (CREDIPAR)' },
    { bankCode: '18889', bankLabel: 'Cortal Consors' },
    { bankCode: '10268', bankLabel: 'Courtois' },
    { bankCode: '14698', bankLabel: 'Coutts & Co (Monaco)' },
    { bankCode: '21670', bankLabel: 'CP Or Devises' },
    { bankCode: '17510', bankLabel: 'Créatis' },
    { bankCode: '11306', bankLabel: 'Crédit Agricole Alpes Provence' },
    { bankCode: '17206', bankLabel: 'Crédit Agricole Alsace Vosges' },
    { bankCode: '14706', bankLabel: 'Crédit Agricole Atlantique Vendée' },
    { bankCode: '15449', bankLabel: 'Crédit Agricole Bretagne' },
    { bankCode: '18706', bankLabel: 'Crédit Agricole Brie Picardie' },
    { bankCode: '17806', bankLabel: 'Crédit Agricole Centre Est' },
    { bankCode: '16806', bankLabel: 'Crédit Agricole Centre France' },
    { bankCode: '14806', bankLabel: 'Crédit Agricole Centre Loire' },
    { bankCode: '11706', bankLabel: 'Crédit Agricole Charente-Maritime Deux-Sèvres' },
    { bankCode: '12406', bankLabel: 'Crédit Agricole Charentes Périgord' },
    { bankCode: '31489', bankLabel: 'Crédit Agricole Corporate and Investment' },
    { bankCode: '13306', bankLabel: 'Crédit Agricole d\'Aquitaine' },
    { bankCode: '11006', bankLabel: 'Crédit Agricole de Champagne Bourgogne' },
    { bankCode: '12006', bankLabel: 'Crédit Agricole de la Corse' },
    { bankCode: '14006', bankLabel: 'Crédit Agricole de la Guadeloupe' },
    { bankCode: '19806', bankLabel: 'Crédit Agricole de la Martinique et de la Guyane' },
    { bankCode: '19906', bankLabel: 'Crédit Agricole de la Réunion' },
    { bankCode: '19406', bankLabel: 'Crédit Agricole de la Touraine et du Poitou' },
    { bankCode: '17906', bankLabel: 'Crédit Agricole de l\'Anjou et du Maine' },
    { bankCode: '16106', bankLabel: 'Crédit Agricole de Lorraine' },
    { bankCode: '11206', bankLabel: 'Crédit Agricole de Nord Midi Pyrénées' },
    { bankCode: '16606', bankLabel: 'Crédit Agricole de Normandie' },
    { bankCode: '18206', bankLabel: 'Crédit Agricole de Paris et d\'Ile de France' },
    { bankCode: '13106', bankLabel: 'Crédit Agricole de Toulouse 31' },
    { bankCode: '12206', bankLabel: 'Crédit Agricole des Côtes d\'Armor' },
    { bankCode: '18106', bankLabel: 'Crédit Agricole des Savoie' },
    { bankCode: '13606', bankLabel: 'Crédit Agricole d\'Ille et Vilaine' },
    { bankCode: '19506', bankLabel: 'Crédit Agricole du Centre Ouest' },
    { bankCode: '12906', bankLabel: 'Crédit Agricole du Finistère' },
    { bankCode: '13506', bankLabel: 'Crédit Agricole du Languedoc' },
    { bankCode: '16006', bankLabel: 'Crédit Agricole du Morbihan' },
    { bankCode: '10206', bankLabel: 'Crédit Agricole du Nord Est' },
    { bankCode: '12506', bankLabel: 'Crédit Agricole Franche Comté' },
    { bankCode: '14506', bankLabel: 'Crédit Agricole Loire et Haute Loire' },
    { bankCode: '16706', bankLabel: 'Crédit Agricole Nord de France' },
    { bankCode: '18306', bankLabel: 'Crédit Agricole Normandie Seine' },
    { bankCode: '19106', bankLabel: 'Crédit Agricole Provence Côte d\'Azur' },
    { bankCode: '16906', bankLabel: 'Crédit Agricole Pyrénées Gascogne' },
    { bankCode: '30006', bankLabel: 'Crédit Agricole SA' },
    { bankCode: '17106', bankLabel: 'Crédit Agricole Sud Méditerranéenne' },
    { bankCode: '13906', bankLabel: 'Crédit Agricole Sud Rhône Alpes' },
    { bankCode: '14406', bankLabel: 'Crédit Agricole Val de France' },
    { bankCode: '10638', bankLabel: 'Crédit Commercial du Sud Ouest' },
    { bankCode: '42559', bankLabel: 'Crédit Coopératif' },
    { bankCode: '11778', bankLabel: 'Crédit du Maroc' },
    { bankCode: '30076', bankLabel: 'Crédit du Nord' },
    { bankCode: '30077', bankLabel: 'Crédit du Nord « Société Marseillaise de Crédit »' },
    { bankCode: '43199', bankLabel: 'Crédit Foncier de France' },
    { bankCode: '12739', bankLabel: 'Crédit Foncier de Monaco' },
    { bankCode: '10160', bankLabel: 'Crédit Immobilier de Monaco' },
    { bankCode: '17219', bankLabel: 'Crédit Maritime' },
    { bankCode: '15149', bankLabel: 'Crédit Municipal Alsace Lorraine' },
    { bankCode: '16170', bankLabel: 'Crédit Municipal Boulogne sur Mer' },
    { bankCode: '18950', bankLabel: 'Crédit Municipal d\'Avignon' },
    { bankCode: '28570', bankLabel: 'Crédit Municipal de Dijon' },
    { bankCode: '18050', bankLabel: 'Crédit Municipal de Lyon' },
    { bankCode: '18470', bankLabel: 'Crédit Municipal de Nantes' },
    { bankCode: '17620', bankLabel: 'Crédit Municipal de Nîmes' },
    { bankCode: '18450', bankLabel: 'Crédit Municipal de Roubaix' },
    { bankCode: '17150', bankLabel: 'Crédit Municipal de Toulon' },
    { bankCode: '45539', bankLabel: 'Crédit Mutuel (Caisse Centrale)' },
    { bankCode: '10278', bankLabel: 'Crédit Mutuel (Caisse Fédérale)' },
    { bankCode: '11808', bankLabel: 'Crédit Mutuel (Fédération)' },
    { bankCode: '14798', bankLabel: 'Crédit Mutuel « CAMEFI »' },
    { bankCode: '16159', bankLabel: 'Crédit Mutuel Antilles Guyane' },
    { bankCode: '15589', bankLabel: 'Crédit Mutuel Arkea' },
    { bankCode: '17149', bankLabel: 'Crédit Mutuel Bretagne Normandie' },
    { bankCode: '15829', bankLabel: 'Crédit Mutuel d\'Anjou' },
    { bankCode: '15959', bankLabel: 'Crédit Mutuel de Normandie' },
    { bankCode: '15459', bankLabel: 'Crédit Mutuel du Centre' },
    { bankCode: '15358', bankLabel: 'Crédit Mutuel Guadeloupe Outre-Mer' },
    { bankCode: '11628', bankLabel: 'Crédit Mutuel Ile de France' },
    { bankCode: '16179', bankLabel: 'Crédit Mutuel Loire-Atlantique Centre-Ouest' },
    { bankCode: '15749', bankLabel: 'Crédit Mutuel Loire-Atlantique Centre-Ouest (Caisse Fédérale)' },
    { bankCode: '15489', bankLabel: 'Crédit Mutuel Maine Anjou Basse-Normandie' },
    { bankCode: '17169', bankLabel: 'Crédit Mutuel Maritime du Littoral Sud Ouest' },
    { bankCode: '13298', bankLabel: 'Crédit Mutuel Nord Europe' },
    { bankCode: '15629', bankLabel: 'Crédit Mutuel Nord Europe (Caisse Fédérale)' },
    { bankCode: '15519', bankLabel: 'Crédit Mutuel Océan' },
    { bankCode: '15348', bankLabel: 'Crédit Mutuel Région Nord' },
    { bankCode: '15899', bankLabel: 'Crédit Mutuel Sud Europe Méditerranée' },
    { bankCode: '18169', bankLabel: 'Crédit Suisse (France)' },
    { bankCode: '14048', bankLabel: 'Crédit Suisse (Monaco)' },
    { bankCode: '43030', bankLabel: 'Degroof France' },
    { bankCode: '12879', bankLabel: 'Delubac et Cie' },
    { bankCode: '17789', bankLabel: 'Deutsche Bank (France)' },
    { bankCode: '16038', bankLabel: 'Dexia (Monaco)' },
    { bankCode: '14998', bankLabel: 'Domofinance' },
    { bankCode: '12939', bankLabel: 'Dupuy de Parseval' },
    { bankCode: '11899', bankLabel: 'BECM - Crédit Mutuel' },
    { bankCode: '13149', bankLabel: 'Edel SNC' },
    { bankCode: '18759', bankLabel: 'EGF Bank (Monaco)' },
    { bankCode: '42959', bankLabel: 'Electro Banque' },
    { bankCode: '43659', bankLabel: 'Espirito Santo et de la Venetie (France)' },
    { bankCode: '15000', bankLabel: 'Euronext Paris' },
    { bankCode: '13179', bankLabel: 'Fiducial' },
    { bankCode: '30488', bankLabel: 'Fortis' },
    { bankCode: '18689', bankLabel: 'Fransabank (France)' },
    { bankCode: '14848', bankLabel: 'GE Money Outremer (General Electric Bank)' },
    { bankCode: '17839', bankLabel: 'GMAC Banque' },
    { bankCode: '27589', bankLabel: 'Groupe Oudart' },
    { bankCode: '18520', bankLabel: 'Groupe SOFEMO' },
    { bankCode: '18289', bankLabel: 'Habib Bank (France)' },
    { bankCode: '13488', bankLabel: 'HSBC (Monaco)' },
    { bankCode: '18629', bankLabel: 'HSBC (Privée)' },
    { bankCode: '30056', bankLabel: 'HSBC France' },
    { bankCode: '45159', bankLabel: 'IEDOM Institut d\'Émission des Départements d\'Outre-Mer' },
    { bankCode: '30438', bankLabel: 'ING' },
    { bankCode: '14559', bankLabel: 'ING Direct' },
    { bankCode: '10128', bankLabel: 'Intesa Sanpaolo' },
    { bankCode: '13688', bankLabel: 'ISBANK GMBH' },
    { bankCode: '24349', bankLabel: 'J. Safra (Monaco)' },
    { bankCode: '30628', bankLabel: 'JP Morgan Chase Bank (France)' },
    { bankCode: '14508', bankLabel: 'Julius Baer (Monaco) SAM' },
    { bankCode: '27800', bankLabel: 'KBC Bank (France)' },
    { bankCode: '13338', bankLabel: 'KBL Monaco Private Bankers' },
    { bankCode: '19069', bankLabel: 'KBL Richelieu Banque Privée' },
    { bankCode: '13259', bankLabel: 'Kolb' },
    { bankCode: '14989', bankLabel: 'Korea Exchange Bank' },
    { bankCode: '20041', bankLabel: 'La Banque Postale' },
    { bankCode: '10011', bankLabel: 'La Banque Postale (Caisse Nationale d\'Épargne)' },
    { bankCode: '10228', bankLabel: 'Laydernier' },
    { bankCode: '30748', bankLabel: 'Lazard Fréres' },
    { bankCode: '30002', bankLabel: 'LCL Le Crédit Lyonnais' },
    { bankCode: '14120', bankLabel: 'Legal and General (France)' },
    { bankCode: '21990', bankLabel: 'Leonardo' },
    { bankCode: '21120', bankLabel: 'Lloyds TSB Bank PLC (Monaco)' },
    { bankCode: '13369', bankLabel: 'Martin Maurel' },
    { bankCode: '13379', bankLabel: 'Marze' },
    { bankCode: '18789', bankLabel: 'Mega international Commercial Bank' },
    { bankCode: '15078', bankLabel: 'MFF' },
    { bankCode: '17959', bankLabel: 'Michel Inchauspé BAMI' },
    { bankCode: '18529', bankLabel: 'Mizuho Corporate Bank (France)' },
    { bankCode: '14690', bankLabel: 'monabanq.' },
    { bankCode: '30478', bankLabel: 'Monte Paschi Banque (France)' },
    { bankCode: '17989', bankLabel: 'National Bank of Abu Dhabi' },
    { bankCode: '15930', bankLabel: 'Natixis' },
    { bankCode: '30007', bankLabel: 'Natixis' },
    { bankCode: '30788', bankLabel: 'Neuflize' },
    { bankCode: '13489', bankLabel: 'Nuger' },
    { bankCode: '14150', bankLabel: 'Oddo' },
    { bankCode: '14168', bankLabel: 'Office des Postes et Telecom de Polynésie' },
    { bankCode: '40978', bankLabel: 'Palatine' },
    { bankCode: '16840', bankLabel: 'Pasche (Monaco)' },
    { bankCode: '13529', bankLabel: 'Pelletier' },
    { bankCode: '11989', bankLabel: 'Pouyanne' },
    { bankCode: '18919', bankLabel: 'Privée 1818' },
    { bankCode: '17919', bankLabel: 'Qatar National Bank (France)' },
    { bankCode: '43789', bankLabel: 'Quilvest Banque Privée' },
    { bankCode: '17649', bankLabel: 'Révillon' },
    { bankCode: '10468', bankLabel: 'Rhône-Alpes' },
    { bankCode: '18669', bankLabel: 'Rothschid et Compagnie' },
    { bankCode: '13579', bankLabel: 'Saint Olive' },
    { bankCode: '17679', bankLabel: 'Société de Banque et d\'Expansion' },
    { bankCode: '14749', bankLabel: 'Société Fire de Banque Sofib' },
    { bankCode: '30003', bankLabel: 'Société Générale' },
    { bankCode: '18319', bankLabel: 'Société Générale Calédonienne de Banque' },
    { bankCode: '18079', bankLabel: 'Société Générale de Banque aux Antilles' },
    { bankCode: '13539', bankLabel: 'Solfea' },
    { bankCode: '15250', bankLabel: 'Sumitomo Mitsui Banking Corp Europe LTD' },
    { bankCode: '14568', bankLabel: 'Svenska Handelsbanken AB' },
    { bankCode: '10558', bankLabel: 'Tarneaud' },
    { bankCode: '41249', bankLabel: 'The Bank of Tokyo Mitsubishi UFJ (France)' },
    { bankCode: '18739', bankLabel: 'The Royal Bank of Scotland (France)' },
    { bankCode: '11449', bankLabel: 'Themis' },
    { bankCode: '43849', bankLabel: 'Tunisian Foreign Bank (France)' },
    { bankCode: '30758', bankLabel: 'UBS (France)' },
    { bankCode: '11999', bankLabel: 'UBS (Monaco)' },
    { bankCode: '40238', bankLabel: 'VTB Direct' },
    { bankCode: '10000', bankLabel: 'CONECS' },
    { bankCode: '16820', bankLabel: 'American Express' },
    { bankCode: '00000', bankLabel: 'American Express' },
    { bankCode: '41539', bankLabel: 'CA Consumer Finance' },
    { bankCode: '41199', bankLabel: 'CIC Iberbanco' },
    { bankCode: '26550', bankLabel: 'GIE Cartes Bancaires' },
    { bankCode: '70000', bankLabel: 'Alma' }
];

export default BANK_CODES;